export default __webpack_public_path__ + "static/media/biodata-12.3232cffe.png";